import moment from "moment";
import { ObjectSchema, mixed, object } from "yup";
import { AvisConstants } from "../../../../data/avisConstants";
import { requiredNumber, requiredString } from "../../../../data/yupConstants";
import {
  PortalAdditionalReportRequestViewModel,
  PortalAdditionalReportViewModel,
} from "../../../../generated/data-contracts";
import { ResCallback } from "../../../../models";

export const selectedReportValidation = (
  selectedReport: PortalAdditionalReportViewModel | undefined,
  hasAnyYearParam: boolean | undefined,
  setFieldValidationTexts: React.Dispatch<
    React.SetStateAction<Record<string, string>>
  >,
  res: ResCallback,
): ObjectSchema<PortalAdditionalReportRequestViewModel> | undefined => {
  const setParamErrorChoose = (reportParameter: string) => {
    setFieldValidationTexts((prevState) => {
      return {
        ...prevState,
        [reportParameter]: res(
          "authors_ReportsPage_ReportDetails_validation_chooseDate",
        ),
      };
    });
  };

  const validationSchema: ObjectSchema<PortalAdditionalReportRequestViewModel> =
    object({
      rightsHolderId: requiredNumber(res),
      reportParams: mixed<Record<string, string>>()
        .when([], {
          is: () => hasAnyYearParam,
          then: (schema) =>
            schema.test(
              "year-parameter-value-is-valid",
              "Invalid year parameter value",
              (value) => {
                if (!value) return false;
                const invalidPropertyValues =
                  selectedReport?.parameters?.filter((p) => {
                    //If param not found or undefined
                    if (!value[p.reportParameter]) {
                      setParamErrorChoose(p.reportParameter);
                      return true;
                    }
                    if (isNaN(parseInt(value[p.reportParameter]))) {
                      setParamErrorChoose(p.reportParameter);
                      return true;
                    }
                  }).length;
                //Prevents from submit if invalid values
                //Specific validation messages for individual dynamic parameters are handled in paramBoxItem component
                return invalidPropertyValues
                  ? invalidPropertyValues === 0
                  : true;
              },
            ),
        })
        .when([], {
          is: () => !hasAnyYearParam,
          then: (schema) =>
            schema.test(
              "date-parameter-value-is-valid",
              "Invalid date parameter value",
              (value) => {
                if (!value) return false;
                const invalidPropertyValues =
                  selectedReport?.parameters?.filter((p) => {
                    //If param not found or undefined
                    if (!value[p.reportParameter]) {
                      setParamErrorChoose(p.reportParameter);
                      return true;
                    }

                    if (
                      !moment(
                        value[p.reportParameter],
                        AvisConstants.date_format,
                        true,
                      ).isValid()
                    ) {
                      setParamErrorChoose(p.reportParameter);
                      return true;
                    }
                  }).length;
                return invalidPropertyValues
                  ? invalidPropertyValues === 0
                  : true;
              },
            ),
        }),
      relativeUrl: requiredString(res),
    });

  return validationSchema;
};
